"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconError = _interopRequireDefault(require("../../icons/icon-error.svg"));

var _CustomReactMarkdown = _interopRequireDefault(require("../MarkdownRenderers/CustomReactMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SubmissionError = function SubmissionErrorComponent(_ref) {
  var children = _ref.children,
      message = _ref.message,
      className = _ref.className;
  var displayedMessage = children || message;

  if (!displayedMessage) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('submission-error', _defineProperty({}, className, className))
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "submission-error__icon"
  }, /*#__PURE__*/_react["default"].createElement(_iconError["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "submission-error__message",
    role: "alert",
    "aria-live": "assertive"
  }, /*#__PURE__*/_react["default"].createElement(_CustomReactMarkdown["default"], {
    source: displayedMessage
  })));
};

SubmissionError.propTypes = {
  message: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]))
};
SubmissionError.defaultProps = {
  message: undefined,
  children: undefined,
  className: ''
};
var _default = SubmissionError;
exports["default"] = _default;